import styled from 'styled-components';

export default styled.div`
    .betslip-share-button {
        margin-top: var(--spacing-8);
    }
`;
